import {withLocalization} from '@epic-core/localization';
import {connectToStores} from 'epic-alt-utils';
import LoginActions from 'epic-fortnite-react/actions/LoginActions';
import Loading from 'epic-fortnite-react/components/common/loading/Loading';
import Error404 from 'epic-fortnite-react/components/error/Error404';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import React from 'react';
import Helmet from 'react-helmet';

import VideoRecapActions from '../../actions/VideoRecapActions';
import LoadScreen from '../../components/loadScreen/LoadScreen';
import VideoRecapSection from '../../components/videoRecap/VideoRecapSection';
import {HeaderStore, LoginStore, VideoRecapStore} from '../../stores';

/**
 * CumstomVideoRecap Page View
 */
@connectToStores
class CustomVideoRecapView extends React.Component {
  static propTypes = {
    videoRecapStore: PropTypes.object,
    loginStore: PropTypes.object,
    location: PropTypes.object,
    getMessage: PropTypes.func,
    tablet: PropTypes.bool,
    mobile: PropTypes.bool,
  };

  state = {
    scenes: {},
    themes: {},
    soundtracks: {},
    audioTracks: {},
  };

  static getStores() {
    return [VideoRecapStore, LoginStore, HeaderStore];
  }

  static getPropsFromStores() {
    return {
      videoRecapStore: VideoRecapStore.getState(),
      loginStore: LoginStore.getState(),
      mobile: HeaderStore.getState().mobile(),
      tablet: HeaderStore.getState().tablet(),
    };
  }

  static getInitialActions() {
    return [VideoRecapActions.getContent];
  }

  getReturnPath = () => {
    const {location} = this.props;
    const query = queryString.parse(location.search) || '';
    return `${location.pathname}?${queryString.stringify(query)}`;
  };

  login = () => {
    LoginActions.requestLogin({
      returnPath: this.getReturnPath(),
    });
  };

  renderAskForLogin = () => {
    const {
      getMessage,
      videoRecapStore: {
        customVideoRecap: {loginImage},
      },
    } = this.props;
    const style = {backgroundImage: `url(${loginImage})`};
    return (
      <div className="customVideoRecapView">
        <div className="background" style={style} />
        <div className="background-overlay">
          <h1>{getMessage('errors.com.epicgames.login')}</h1>
          <button onClick={this.login} className="btn btn-primary">
            {getMessage('epic.common.login')}
          </button>
        </div>
      </div>
    );
  };

  renderNotEligible = () => {
    const {
      getMessage,
      videoRecapStore: {
        customVideoRecap: {ineligibleImage},
      },
    } = this.props;
    const style = {backgroundImage: `url(${ineligibleImage})`};
    return (
      <div className="customVideoRecapView">
        <div className="background " style={style} />
        <div className="background-overlay">
          <h1>{getMessage('epic.fortnite.idomoo.video.notEligible')}</h1>
          <p>{getMessage('epic.fortnite.idomoo.video.notEligible.desc')}</p>
        </div>
      </div>
    );
  };

  createVideo = () => {
    const {scenes, soundtracks, themes} = this.state;
    const payload = Object.keys(scenes).map((key) => {
      return {
        key,
        val: 'yes',
      };
    });
    if (Object.keys(themes).length) {
      payload.push({
        key: 'user_color',
        val: Object.keys(themes)[0],
      });
    }

    if (Object.keys(soundtracks)[0]) {
      payload.push({
        key: 'user_soundtrack',
        val: Object.keys(soundtracks)[0],
      });
    }
    VideoRecapActions.generateVideo(payload);
  };

  getItems = (Node, type, items, limit = 6, extraProps = {}) => {
    const stateKey = `${type}s`;
    const limitReached = Object.keys(this.state[stateKey]).length >= limit;
    return items.map((item, i) => {
      const _item = this.getSelectedItem(stateKey, item.key);
      return (
        <Node
          key={`${type}-${i}`}
          data={item}
          selected={!!_item}
          selectedItemValue={_item}
          clickItem={() => this.toggleItem(stateKey, item.key, limit)}
          limitReached={limitReached}
          {...extraProps}
        />
      );
    });
  };

  handlePlay = (audioKey, {togglePlay, stop}) => {
    // pause all previous audio, if any
    for (const key in this.state.audioTracks) {
      if (key !== audioKey) {
        this.state.audioTracks[key].stop();
      }
    }
    // store audio if does not exist in list
    if (!this.state.audioTracks[audioKey]) {
      const audioTracks = Object.assign(this.state.audioTracks, {});
      audioTracks[audioKey] = {stop};
      this.setState({audioTracks});
    }
    // play audio
    togglePlay();
  };

  toggleItem = (stateKey, selectedItemKey, limit = 6) => {
    let selectedItems = null;
    if (this.getSelectedItem(stateKey, selectedItemKey)) {
      selectedItems = Object.assign(this.state[stateKey], {});
      for (const key in selectedItems) {
        if (
          typeof key === 'string' &&
          selectedItems[key].number > selectedItems[selectedItemKey].number
        ) {
          --selectedItems[key].number;
        }
      }
      delete selectedItems[selectedItemKey];
    } else {
      switch (limit) {
        case 1:
          selectedItems = {[selectedItemKey]: {value: true, number: 1}};
          break;
        default: {
          const length = Object.keys(this.state[stateKey]).length;
          if (length >= limit) {
            return;
          }
          const number = length + 1;
          selectedItems = Object.assign(this.state[stateKey], {
            [selectedItemKey]: {value: true, number},
          });
          break;
        }
      }
    }
    this.setState({[stateKey]: selectedItems});
  };

  getSelectedItem = (stateKey, itemKey) => {
    const item = this.state[stateKey];
    return item[itemKey];
  };

  clearSelections = () => {
    this.setState({
      scenes: {},
    });
  };

  render() {
    const {getMessage, videoRecapStore, loginStore} = this.props;
    const {isLoggedIn} = loginStore;
    const {customVideoRecap, loading, creating, error, errorMsg} = videoRecapStore;
    if (loading) return <LoadScreen show={loading} />;
    if (!this.props.videoRecapStore || !this.props.videoRecapStore.customVideoRecap) {
      return <Error404 />;
    }
    if (!isLoggedIn) return this.renderAskForLogin();

    if (!customVideoRecap || !customVideoRecap.eligible) return this.renderNotEligible();
    const isPruned = Object.keys(this.state.scenes).length > 0;

    const sections = [];
    for (const key in customVideoRecap.sections) {
      if (typeof key === 'string') {
        const section = customVideoRecap.sections[key];
        sections.push(
          <VideoRecapSection
            key={key}
            section={section}
            mobile={this.props.mobile}
            tablet={this.props.tablet}
            getMessage={getMessage}
            getItems={this.getItems}
            isPruned={isPruned}
            clearSelections={this.clearSelections}
            handlePlay={this.handlePlay}
          />
        );
      }
    }

    const tags = [
      {itemProp: 'name', content: customVideoRecap.metaTitle},
      {itemProp: 'description', content: customVideoRecap.metaDescription},
      {itemProp: 'image', content: customVideoRecap.metaImage},
      {name: 'description', content: customVideoRecap.metaDescription},
      {name: 'twitter:title', content: customVideoRecap.metaTitle},
      {name: 'twitter:description', content: customVideoRecap.metaDescription},
      {name: 'twitter:image', content: customVideoRecap.metaImage},
      {property: 'og:title', content: customVideoRecap.metaTitle},
      {property: 'og:image', content: customVideoRecap.metaImage},
      {property: 'og:description', content: customVideoRecap.metaDescription},
    ];

    return (
      <div className="customVideoRecapView">
        <Helmet meta={tags} title={customVideoRecap.metaTitle} />
        {creating ? (
          <div className="cvrv-creating-overlay">
            <Loading isLoading />
            <h2>{getMessage('epic.fortnite.idomoo.video.creatingVideo')}</h2>
          </div>
        ) : null}
        {error ? (
          <div className="cvrv-creating-overlay">
            <h2>{getMessage(errorMsg)}</h2>
            <button className="goback" onClick={VideoRecapActions.resetError}>
              {getMessage('epic.common.back')}
            </button>
          </div>
        ) : null}
        {sections}
        <button className="cvrv-btn divider" disabled={!isPruned} onClick={this.createVideo}>
          {getMessage('epic.fortnite.idomoo.video.createVideo')}
        </button>
      </div>
    );
  }
}

export default withLocalization(CustomVideoRecapView);
